import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Download } from 'lucide-react'
import { useParams } from 'react-router'

// Service & Utils
import { CertificateRequirements } from '@/components/CertificateRequirements'
import { Skeleton } from '@/components/elements/skeleton'
import { Layout } from '@/components/Layout'
import { getCertificate } from '@/services/certificates.service'

import StudentTable from './StudentTable'

function InstructorCertificate() {
  const { certificateId, entityId } = useParams()

  const { data: certificate, isPending } = useQuery({
    queryKey: ['accounts', 'instructors', 'certificates', certificateId, entityId],
    queryFn: () => getCertificate({ entityId, id: certificateId }),
    placeholderData: keepPreviousData,
  })
  if (isPending) {
    return (
      <Layout
        breadcrumbs={[
          'Instructor',
          {
            pathname: `/accounts/${entityId}/instructors/certificates`,
            title: 'Course Assignments',
          },
          'Course',
        ]}
      >
        <Layout.Heading title="Course" />

        <Skeleton className="h-[90%] w-[90%]" />
      </Layout>
    )
  }

  return (
    <Layout
      breadcrumbs={[
        'Instructor',
        {
          pathname: `/accounts/${entityId}/instructors/certificates`,
          title: 'Course Assignments',
        },
        certificate.name,
      ]}
    >
      <Layout.Heading title={certificate.name} />
      <div className="flex flex-col gap-4">
        <dl className="flex w-full flex-row flex-wrap justify-between gap-4">
          {[
            {
              label: 'Required course modules',
              content: <CertificateRequirements certificate={certificate} />,
            },
            // TODO: Uncomment when these features are implemented
            // { label: 'Next training', content: 'xx/xx/xxxx' },
            // { label: 'Bank', content: 'xx' },
            { label: 'Granted', content: certificate.numCertifiedStudents },
          ].map(({ label, content }) => (
            <div key={label} className="flex flex-col gap-1">
              <dt className="font-semibold uppercase">{label}</dt>
              <dd>{content}</dd>
            </div>
          ))}
        </dl>
        {certificate.instructorAssets && certificate.instructorAssets.length > 0 && (
          <div className="flex flex-col gap-2">
            <h3 className="font-semibold uppercase">Instructor Assets</h3>
            <div className="flex flex-col gap-2">
              {certificate.instructorAssets.map((asset) => (
                <div key={asset.id} className="flex items-center gap-2">
                  <a
                    href={asset.signedFilePath}
                    download
                    rel="noreferrer"
                    className="text-primary hover:text-foreground flex items-center gap-2"
                  >
                    <Download className="h-4 w-4" />
                    <span>{asset.fileDisplayName}</span>
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
        <StudentTable certificate={certificate} />
      </div>
    </Layout>
  )
}

export default InstructorCertificate
